import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Players from '../views/Players'
import Player from '../views/Player'
import Teams from '../views/Teams'
import Games from '../views/Games'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/player/:id',
    name: 'Player',
    component: Player
  },
  {
    path: '/players',
    name: 'Players',
    component: Players
  },
  {
    path: '/teams',
    name: 'Teams',
    component: Teams
  },
  {
    path: '/games',
    name: 'Games',
    component: Games
  },
]

const router = new VueRouter({
  base: 'vue',
  routes
})

export default router
